// import React, { useEffect, useRef, useState } from 'react';

// const images = [
//   'https://ik.imagekit.io/mhcockpit1/image.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle%2013.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle%2015.jpg',
//   'https://ik.imagekit.io/mhcockpit1/image.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle%2013.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle.jpg',
//   'https://ik.imagekit.io/mhcockpit1/Rectangle%2015.jpg'
// ];

// export default function Gallery() {
//   const [active, setActive] = useState(3);
//   const itemsRef = useRef([]);
//   const dragStartX = useRef(null);
//   const dragEndX = useRef(null);
//   const wheelTimeout = useRef(null);

//   useEffect(() => {
//     const items = itemsRef.current;
//     if (!items.length || !items[active]) return;

//     items[active].style.transform = 'none';
//     items[active].style.zIndex = 100;
//     items[active].style.filter = 'none';
//     items[active].style.opacity = 1;

//     let stt = 0;
//     for (let i = active + 1; i < items.length; i++) {
//       stt++;
//       items[i].style.transform = `translateX(${120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(-1deg)`;
//       items[i].style.zIndex = 100 - stt;
//       items[i].style.filter = 'blur(5px)';
//       items[i].style.opacity = stt > 2 ? 0 : 0.6;
//     }

//     stt = 0;
//     for (let i = active - 1; i >= 0; i--) {
//       stt++;
//       items[i].style.transform = `translateX(${-120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(1deg)`;
//       items[i].style.zIndex = 100 - stt;
//       items[i].style.filter = 'blur(5px)';
//       items[i].style.opacity = stt > 2 ? 0 : 0.6;
//     }
//   }, [active]);

//   const handleNext = () => {
//     setActive((prev) => (prev + 1 < images.length ? prev + 1 : prev));
//   };

//   const handlePrev = () => {
//     setActive((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
//   };

//   // Touch Events
//   const handleTouchStart = (e) => {
//     dragStartX.current = e.touches[0].clientX;
//   };

//   const handleTouchMove = (e) => {
//     dragEndX.current = e.touches[0].clientX;
//   };

//   const handleTouchEnd = () => {
//     handleSwipe();
//   };

//   // Mouse Events
//   const handleMouseDown = (e) => {
//     dragStartX.current = e.clientX;
//     dragEndX.current = null;

//     window.addEventListener('mousemove', handleMouseMove);
//     window.addEventListener('mouseup', handleMouseUp);
//   };

//   const handleMouseMove = (e) => {
//     dragEndX.current = e.clientX;
//   };

//   const handleMouseUp = () => {
//     window.removeEventListener('mousemove', handleMouseMove);
//     window.removeEventListener('mouseup', handleMouseUp);
//     handleSwipe();
//   };

//   // Swipe logic
//   const handleSwipe = () => {
//     if (dragStartX.current != null && dragEndX.current != null) {
//       const deltaX = dragStartX.current - dragEndX.current;
//       if (Math.abs(deltaX) > 50) {
//         if (deltaX > 0) {
//           handleNext(); // Swipe Left
//         } else {
//           handlePrev(); // Swipe Right
//         }
//       }
//     }
//     dragStartX.current = null;
//     dragEndX.current = null;
//   };

//   // Wheel event for trackpad scroll
//   const handleWheel = (e) => {
//     if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 30) {
//       if (wheelTimeout.current) return; // Throttle to avoid fast scroll fire
//       if (e.deltaX > 0) {
//         handleNext(); // Scroll right
//       } else {
//         handlePrev(); // Scroll left
//       }
//       wheelTimeout.current = setTimeout(() => {
//         wheelTimeout.current = null;
//       }, 500); // throttle duration
//     }
//   };

//   return (
//     <div>
//       <div className="min-h-screen flex items-center justify-center overflow-hidden bg-white">
//         <div className="relative w-full max-w-6xl h-[370px]">
//           <div
//             className="relative w-full h-full overflow-hidden"
//             onTouchStart={handleTouchStart}
//             onTouchMove={handleTouchMove}
//             onTouchEnd={handleTouchEnd}
//             onMouseDown={handleMouseDown}
//             onWheel={handleWheel}
//           >
//             {images.map((src, index) => (
//               <div
//                 key={index}
//                 ref={(el) => (itemsRef.current[index] = el)}
//                 className="absolute w-[200px] h-[320px] left-[calc(50%-110px)] transition-all duration-500"
//               >
//                 <img
//                   src={src}
//                   alt={`Slide ${index}`}
//                   className="w-full h-full object-cover rounded-lg"
//                 />
//               </div>
//             ))}
//             <button
//               onClick={handlePrev}
//               className="absolute top-[40%] left-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
//             >
//               &lt;
//             </button>
//             <button
//               onClick={handleNext}
//               className="absolute top-[40%] right-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
//             >
//               &gt;
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }




// import React, { useEffect, useRef, useState } from 'react';
// import Categorize from './Categorize';

// const sliderImages = [
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/1.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/2.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/3.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/4.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/5.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/6.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/7.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/8.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/9.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/10.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/11.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/12.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/13.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/14.webp',
//     'https://albidayahgroups.com/Media/Gallery/Portrait/webp/15.webp',
// ];

// export default function GalleryPage() {
//     const [active, setActive] = useState(3);
//     const itemsRef = useRef([]);
//     const dragStartX = useRef(null);
//     const dragEndX = useRef(null);
//     const wheelTimeout = useRef(null);
//     const [modalImageSrc, setModalImageSrc] = useState(null);

//     useEffect(() => {
//         const items = itemsRef.current;
//         if (!items.length || !items[active]) return;

//         items[active].style.transform = 'none';
//         items[active].style.zIndex = 100;
//         items[active].style.filter = 'none';
//         items[active].style.opacity = 1;

//         let stt = 0;
//         for (let i = active + 1; i < items.length; i++) {
//             stt++;
//             items[i].style.transform = `translateX(${120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(-1deg)`;
//             items[i].style.zIndex = 100 - stt;
//             items[i].style.filter = 'blur(5px)';
//             items[i].style.opacity = stt > 2 ? 0 : 0.6;
//         }

//         stt = 0;
//         for (let i = active - 1; i >= 0; i--) {
//             stt++;
//             items[i].style.transform = `translateX(${-120 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(1deg)`;
//             items[i].style.zIndex = 100 - stt;
//             items[i].style.filter = 'blur(5px)';
//             items[i].style.opacity = stt > 2 ? 0 : 0.6;
//         }
//     }, [active]);

//     const handleNext = () => {
//         setActive((prev) => (prev + 1 < sliderImages.length ? prev + 1 : prev));
//     };

//     const handlePrev = () => {
//         setActive((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
//     };

//     const handleTouchStart = (e) => { dragStartX.current = e.touches[0].clientX; };
//     const handleTouchMove = (e) => { dragEndX.current = e.touches[0].clientX; };
//     const handleTouchEnd = () => { handleSwipe(); };

//     const handleMouseDown = (e) => {
//         dragStartX.current = e.clientX;
//         dragEndX.current = null;
//         window.addEventListener('mousemove', handleMouseMove);
//         window.addEventListener('mouseup', handleMouseUp);
//     };

//     const handleMouseMove = (e) => { dragEndX.current = e.clientX; };
//     const handleMouseUp = () => {
//         window.removeEventListener('mousemove', handleMouseMove);
//         window.removeEventListener('mouseup', handleMouseUp);
//         handleSwipe();
//     };

//     const handleSwipe = () => {
//         if (dragStartX.current != null && dragEndX.current != null) {
//             const deltaX = dragStartX.current - dragEndX.current;
//             if (Math.abs(deltaX) > 50) {
//                 deltaX > 0 ? handleNext() : handlePrev();
//             }
//         }
//         dragStartX.current = null;
//         dragEndX.current = null;
//     };

//     const handleWheel = (e) => {
//         if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 30) {
//             if (wheelTimeout.current) return;
//             e.deltaX > 0 ? handleNext() : handlePrev();
//             wheelTimeout.current = setTimeout(() => {
//                 wheelTimeout.current = null;
//             }, 500);
//         }
//     };

//     return (
//         <div className="pt-40">
//             {/* Slider Section */}
//             <div className=" flex items-center justify-center overflow-hidden">
//                 <div className="relative w-full max-w-6xl h-[370px]">
//                     <div
//                         className="relative w-full h-full overflow-hidden"
//                         onTouchStart={handleTouchStart}
//                         onTouchMove={handleTouchMove}
//                         onTouchEnd={handleTouchEnd}
//                         onMouseDown={handleMouseDown}
//                         onWheel={handleWheel}
//                     >
//                         {sliderImages.map((src, index) => (
//                             <div
//                                 key={index}
//                                 ref={(el) => (itemsRef.current[index] = el)}
//                                 className="absolute w-[200px] h-full left-[calc(50%-110px)] transition-all duration-500"
//                             >
//                                 <img
//                                     src={src}
//                                     alt={`Slide ${index}`}
//                                     className="w-full h-full object-cover rounded-lg"
//                                 />
//                             </div>
//                         ))}
//                         <button
//                             onClick={handlePrev}
//                             className="absolute top-[40%] left-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
//                         >
//                             &lt;
//                         </button>
//                         <button
//                             onClick={handleNext}
//                             className="absolute top-[40%] right-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
//                         >
//                             &gt;
//                         </button>
//                     </div>
//                 </div>
//             </div>
//             <Categorize />
//         </div>
//     );
// }




import React, { useEffect, useRef, useState } from 'react';
import Categorize from './Categorize';

const sliderImages = [
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/1.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/2.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/3.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/4.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/5.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/6.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/7.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/8.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/9.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/10.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/11.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/12.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/13.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/14.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/15.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/16.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/17.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/18.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/19.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/20.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/21.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/22.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/23.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/24.webp',
    'https://albidayahgroups.com/Media/Gallery/Portrait/New/25.webp',
];

export default function GalleryPage() {
    const [active, setActive] = useState(3);
    const itemsRef = useRef([]);
    const dragStartX = useRef(null);
    const dragEndX = useRef(null);
    const wheelTimeout = useRef(null);

    // useEffect(() => {
    //     const items = itemsRef.current;
    //     if (!items.length || !items[active]) return;

    //     items[active].style.transform = 'none';
    //     items[active].style.zIndex = 100;
    //     items[active].style.filter = 'none';
    //     items[active].style.opacity = 1;

    //     let stt = 0;
    //     for (let i = active + 1; i < items.length; i++) {
    //         stt++;
    //         items[i].style.transform = `translateX(${100 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(-1deg)`;
    //         items[i].style.zIndex = 100 - stt;
    //         items[i].style.filter = 'blur(5px)';
    //         items[i].style.opacity = stt > 3 ? 0 : 0.6;
    //     }

    //     stt = 0;
    //     for (let i = active - 1; i >= 0; i--) {
    //         stt++;
    //         items[i].style.transform = `translateX(${-100 * stt}px) scale(${1 - 0.2 * stt}) perspective(16px) rotateY(1deg)`;
    //         items[i].style.zIndex = 100 - stt;
    //         items[i].style.filter = 'blur(5px)';
    //         items[i].style.opacity = stt > 3 ? 0 : 0.6;
    //     }
    // }, [active]);


    useEffect(() => {
    const items = itemsRef.current;
    if (!items.length) return;

    const total = sliderImages.length;
    const visibleRange = 3; // How many items to show on each side

    for (let i = 0; i < total; i++) {
        const el = items[i];
        const offset = ((i - active + total) % total + total) % total; // circular diff
        let pos = offset;

        if (offset > total / 2) {
            pos = offset - total; // negative direction
        }

        const absPos = Math.abs(pos);

        if (absPos > visibleRange) {
            el.style.opacity = 0;
            el.style.zIndex = 0;
            el.style.transform = 'scale(0.5)';
        } else {
            el.style.opacity = absPos === 0 ? 1 : 0.6;
            el.style.zIndex = 100 - absPos;
            el.style.transform = `
                translateX(${pos * 100}px)
                scale(${1 - 0.2 * absPos})
                perspective(16px)
                rotateY(${absPos === 0 ? '0deg' : pos > 0 ? '-1deg' : '1deg'})
            `;
            el.style.filter = absPos === 0 ? 'none' : 'blur(5px)';
        }
    }
}, [active, sliderImages.length]);


    // const handleNext = () => {
    //     setActive((prev) => (prev + 1 < sliderImages.length ? prev + 1 : prev));
    // };

    // const handlePrev = () => {
    //     setActive((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
    // };


    const handleNext = () => {
    setActive((prev) => (prev + 1) % sliderImages.length);
};

const handlePrev = () => {
    setActive((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
};

useEffect(() => {
    const interval = setInterval(() => {
        handleNext();
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
}, []);

    const handleTouchStart = (e) => { dragStartX.current = e.touches[0].clientX; };
    const handleTouchMove = (e) => { dragEndX.current = e.touches[0].clientX; };
    const handleTouchEnd = () => { handleSwipe(); };

    const handleMouseDown = (e) => {
        dragStartX.current = e.clientX;
        dragEndX.current = null;
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => { dragEndX.current = e.clientX; };
    const handleMouseUp = () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        handleSwipe();
    };

    const handleSwipe = () => {
        if (dragStartX.current != null && dragEndX.current != null) {
            const deltaX = dragStartX.current - dragEndX.current;
            if (Math.abs(deltaX) > 50) {
                deltaX > 0 ? handleNext() : handlePrev();
            }
        }
        dragStartX.current = null;
        dragEndX.current = null;
    };

    const handleWheel = (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 30) {
            if (wheelTimeout.current) return;
            e.deltaX > 0 ? handleNext() : handlePrev();
            wheelTimeout.current = setTimeout(() => {
                wheelTimeout.current = null;
            }, 500);
        }
    };

    return (
        <div className="pt-40">
            {/* Slider Section */}
            <div className="flex items-center justify-center overflow-hidden">
                <div className="relative w-full max-w-6xl h-[300px] max-sm:h-[200px]">
                    <div
                        className="relative w-full h-full overflow-hidden"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                        onWheel={handleWheel}
                    >
                        {sliderImages.map((src, index) => (
                            <div
                                key={index}
                                ref={(el) => (itemsRef.current[index] = el)}
                                className="absolute w-[300px] max-sm:w-[200px] h-[300px] max-sm:h-[200px] left-[calc(50%-150px)] max-sm:left-[calc(50%-100px)] transition-all duration-500"
                            >
                                <img
                                    src={src}
                                    alt={`Slide ${index}`}
                                    className="w-full h-full object-cover rounded-lg"
                                />
                            </div>
                        ))}
                        <button
                            onClick={handlePrev}
                            className="absolute top-[40%] left-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
                        >
                            &lt;
                        </button>
                        <button
                            onClick={handleNext}
                            className="absolute top-[40%] right-[50px] text-black text-xl font-bold bg-transparent border-none z-10"
                        >
                            &gt;
                        </button>
                    </div>
                </div>
            </div>
            <Categorize />
        </div>
    );
}
